import { Form, Row, Col } from 'react-bootstrap';

function MiscellaneousForm({ form, setForm, stepSubmitted }) {
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Credit Period Allowed</Form.Label>
                        <Form.Control
                            name="credit_period_allowed"
                            value={form.credit_period_allowed}
                            onChange={handleChange}
                            placeholder="e.g. 30 days"
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>PAN No.</Form.Label>
                        <Form.Control
                            name="pan_no"
                            value={form.pan_no}
                            onChange={handleChange}
                            placeholder="e.g. ABCDE1234F"
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>TAN No.</Form.Label>
                        <Form.Control
                            name="tan_no"
                            value={form.tan_no}
                            onChange={handleChange}
                            placeholder="e.g. MUMA12345B"
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>FSSAI No.</Form.Label>
                        <Form.Control
                            name="fssai_no"
                            value={form.fssai_no}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                {/* <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="OnHold">On Hold</option>
                            <option value="Blocked">Blocked</option>
                            <option value="Deactive">Deactive</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={6} xl={4} className="d-flex align-items-center">
                    <Form.Group className="mb-2 mt-4">
                        <Form.Check
                            type="checkbox"
                            name="approved"
                            checked={form.approved}
                            onChange={handleChange}
                            label="Approved"
                        />
                    </Form.Group>
                </Col> */}
            </Row>
        </div>
    );
}

export default MiscellaneousForm;
